import { CheckCircleFilled } from '@ant-design/icons';
import { rem } from 'polished';
import styled from 'styled-components';

import { LABEL_2_REG_2 } from 'src/client/constants/text';

type ContainerProps = {
  $isSelected: boolean;
  $isDisabled: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 200px;

  background: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  ${(props) =>
    props.$isSelected &&
    `
    border: 2px solid ${props.theme.colors.darkEmphasis1};
    background: white;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  `}

  ${(props) =>
    props.$isDisabled &&
    `
    opacity: 0.4;
    cursor: not-allowed;
  `}

  &:focus {
    outline: 1px solid ${(props) => props.theme.colors.cyan400};
    outline-offset: 2px;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 150px;

  border: 1px solid ${(props) => props.theme.colors.gray4};
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 0;
  overflow: hidden;
  padding: 4px;
  margin-bottom: 8px;
`;

export const RecipientImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

export const PlaceholderLetter = styled.div`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-weight: ${(props) => props.theme.fontWeights.regular};
  color: black;

  font-size: ${rem('12px')};
  line-height: ${rem('16px')};
`;

export const LoadingPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    ${(props) => props.theme.colors.gray4} 25%,
    ${(props) => props.theme.colors.gray3} 50%,
    ${(props) => props.theme.colors.gray4} 75%
  );
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 8px;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const RecipientName = styled.div`
  text-align: center;
  width: 100%;
  flex-shrink: 0;

  p {
    ${LABEL_2_REG_2}
    font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  }
`;

export const SelectedIndicator = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`;

export const CheckmarkIcon = styled(CheckCircleFilled)`
  font-size: 24px;
  background-color: white;
  border-radius: 50%;
`;
